import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/lib/guards';

export const Route = createFileRoute('/_staff-fullscreen')({
  beforeLoad: (ctx) => {
    requireAuth({ location: ctx.location });
  },
  component: FullscreenLayout,
});

function FullscreenLayout() {
  return <Outlet />;
}
